<template>
  <div class="snow">
    <div>
      <v-container class="fill-height">
        <v-layout wrap row>
          <v-flex xs12 md8 lg8 xl7 class="pa-8 align-self-center">
            <v-flex>
              <h1
                class="text-uppercase hidden-sm-and-down"
                style="color: #7D9B38; font-size: 3rem"
              >
                Digital-Report 2020
              </h1>
            </v-flex>
            <v-flex>
              <h1
                class="text-uppercase hidden-md-and-up"
                style="color: #7D9B38; font-size: 2rem"
              >
                Digital-Report 2020
              </h1>
            </v-flex>
            <v-flex>
              <h2
                class="text-uppercase headline"
                style="color: #666; 
                font-family: Foro, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif !important; 
                font-weight: bold"
              >
                Non-Profits &amp; IT
              </h2>
            </v-flex>
            <v-flex xs12 md4 lg4 xl5 class="align-self-center hidden-md-and-up">
              <v-col class="mt-5">
                <img src="/images/Keyvisual.svg" height="350px" />
              </v-col>
            </v-flex>
            <v-flex mt-8 mb-8>
              <p class="black--text body mt-5">
                Digitalisierung ist allgegenwärtig, egal ob Freizeit oder Beruf.
                Doch wie digital ist eigentlich die deutsche Zivilgesellschaft?
                Der Digital-Report 2020, die aktuell größte Studie zum Thema
                Digitalisierung bei Non-Profits in Deutschland, gibt umfassende
                Antworten.
              </p>
            </v-flex>
            <v-btn
              color="accent"
              class="ma-2"
              dark
              bottom
              depressed
              rounded
              min-width="200"
              @click="$vuetify.goTo('#inhalt')"
              ><span class="mr-2">Ergebnisse </span>
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
            <v-btn
              color="accent"
              class="ma-2"
              dark
              bottom
              depressed
              rounded
              min-width="200"
              href="https://www.hausdesstiftens.org/wp-content/uploads/Digital-Report-2020-Final.pdf"
              target="blank"
              ><span class="mr-2">Print-Report</span>
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 md4 lg4 xl5 class="align-self-center hidden-sm-and-down">
            <v-col class="mt-5">
              <img src="/images/Keyvisual.svg" />
            </v-col>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div class="pa-2 px-2" style="background-color: #fff;">
      <v-layout row>
        <v-flex sm6 md3 pa-4 class="text-center ">
          <p>Ein Projekt von:</p>
          <v-img src="/images/logo-hds.png" max-height="75px" contain></v-img>
        </v-flex>

        <v-flex sm6 md3 pa-4 class="text-center ">
          <p>Mit Unterstützung von:</p>
          <v-img
            src="/images/logo_correlaid_2.png"
            max-height="75px"
            contain
          ></v-img>
        </v-flex>

        <v-flex sm6 md3 pa-4 class="text-center ">
          <p>Wissenschaftliche Leitung:</p>
          <v-img
            src="/images/04_Logo_Fakultaet_BWL_DE_RGB.png"
            max-height="75px"
            contain
          ></v-img>
        </v-flex>

        <v-flex sm6 md3 pa-4 class="text-center  ">
          <p>Gefördert durch:</p>
          <v-img src="/images/logo_bmi_2.jpg" max-height="75px" contain></v-img>
        </v-flex>
      </v-layout>
    </div>
    <Contenttable></Contenttable>
    <toolstable></toolstable>
    <chancenHerausforderungen
      id="chancenHerausforderungen"
    ></chancenHerausforderungen>
    <statusquo id="statusquo"></statusquo>
    <digitaleOrganisationen
      id="digitaleOrganisationen"
    ></digitaleOrganisationen>
  </div>
</template>

<script>
import Contenttable from "@/components/layout/Contenttable.vue";
import Toolstable from "@/components/layout/Toolstable.vue";
import ChancenHerausforderungen from "@/components/topics/ChancenHerausforderungen.vue";
import Statusquo from "@/components/topics/Statusquo.vue";
import DigitaleOrganisationen from "@/components/topics/DigitaleOrganisationen.vue";

export default {
  data() {
    return {
      tab: null
    };
  },
  name: "report",
  components: {
    Contenttable,
    Toolstable,
    ChancenHerausforderungen,
    Statusquo,
    DigitaleOrganisationen
  }
};
</script>

<style scoped>
.snow {
  background-color: #f5f5f5;
}

.fill-height {
  min-height: 80vh;
}
</style>
